import React, { useState } from "react";
import { Row, Col, Button, Table, Form, Modal } from "react-bootstrap";
import allMetrics from "data/allMetrics.js";
import CustomFormCheck from "utils/CustomFormCheck";
import CustomDropdown from "utils/CustomDropdown";

const allMetricData = allMetrics();

export default function ConfigureGoalsModal(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const btnColor = props.service == "seo" ? "success" : "info";
  const metricList = props.metricList;
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const startDate = moment("2018-01-01");
  const todaysDate = moment();
  const endDate = todaysDate.add(1, "year");
  const yearsDiff = Math.ceil(endDate.diff(startDate, "years", true));
  const yearsArray = [...Array(yearsDiff)].map((empty, index) => startDate.year() + index).reverse();
  return (
    <>
      <Button className="py-1 f14 mb-4 configure-goals-btn" style={{ paddingLeft: "39px", paddingRight: "39px", whiteSpace: "nowrap" }} variant={btnColor} onClick={handleShow} id={props.selectedDashboardId}>
        Configure goal metrics
      </Button>

      <Modal show={show} onHide={handleClose} dialogClassName={`configure-goals-modal ${props.service}`}>
        <Modal.Header closeButton>
          <Modal.Title>Configure goal metrics</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className="px-2">
              <div>
                <Table className="select-date-table">
                  <tbody>
                    <tr>
                      <td style={{ width: "50px" }} className="f16 text-left pl-0">
                        For:
                      </td>
                      <td>
                        {props.service === "ppc" ? (
                          <Form.Control
                            className="primary goals-campaign-selector"
                            style={{ width: "327px" }}
                            as="select"
                            value={props.selectedDashboardId}
                            onChange={(e) => {
                              props.setSelectedDashboardId(e.target.value);
                            }}>
                            {props.dashboards.map((dashboard) => {
                              return (
                                <option key={dashboard.name} value={dashboard.id}>
                                  {dashboard.name}
                                </option>
                              );
                            })}
                          </Form.Control>
                        ) : (
                          <CustomDropdown
                            configure={true}
                            dashboardId={props.selectedDashboardId}
                            platformName={props.service}
                            section="Goals"
                            dashboards={props.dashboards}
                            selectedDashboardId={props.selectedDashboardId}
                            setSelectedDashboardId={props.setSelectedDashboardId}
                            selectedDashboard={props.selectedDashboard}
                            setSelectedDashboard={props.setSelectedDashboard}
                          />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
          <Row className="pt-4">
            <Col>
              <p className="pb-2">Metrics to set goals for:</p>
              <ul className="metric-list ml-4">
                {typeof metricList != "undefined" &&
                  Object.keys(metricList).map((metricName, index) => {
                    const metric = metricList[metricName];
                    const checked = props.checkedMetrics && props.checkedMetrics.includes(metricName) ? true : false;
                    if (metric) {
                      return (
                        <li key={metricName + props.selectedDashboardId}>
                          <CustomFormCheck
                            goalConfig
                            id={metricName}
                            label={metric.name.title}
                            checked={checked}
                            onChange={() => props.handleMetricCheck(props.selectedDashboardId, props.selectedYear, metricName, !checked)}
                          />
                        </li>
                      );
                    } else {
                      return <li key={metricName}>{`${metricName} could not be found in metricData.json`}</li>;
                    }
                  })}
              </ul>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="mx-auto mr-lg-auto ml-lg-0"
            variant="info"
            onClick={() => {
              const reset = confirm("Are you sure? this would clear away your input for goals");
              if (reset) {
                let savedCheckedMetrics = {};
                props.dashboards.forEach((dashboard, index) => {
                  savedCheckedMetrics[dashboard.id] = {};
                  yearsArray.forEach((year) => {
                    // Get a list of which metrics have been saved to the dashboard's goals
                    let newDashboards = props.dashboards;
                    const goals = allMetricData.metricsByDashboard[`${props.service}`].defaults[`${props.accountType}`].goalsAndProjections;
                    savedCheckedMetrics[dashboard.id][year] = goals ? Object.keys(goals) : [];

                    // Clear everything at first to remove old metrics from dashboard.goals
                    newDashboards[index]["goals"][year] = {};
                    months.forEach((month) => {
                      newDashboards[index]["goals"][year][month] = {};
                    });

                    // Fill-in default metrics with blanks
                    savedCheckedMetrics[dashboard.id][year].forEach((metricName) => {
                      months.forEach((month) => {
                        newDashboards[index]["goals"][year][month][metricName] = "";
                      });
                    });

                    props.setCheckedMetrics({ ...savedCheckedMetrics });
                    props.setDashboards([...newDashboards]);
                  });
                });
              }
            }}>
              Reset this selection to default
            </Button>
            <span style={{ paddingLeft:'.5rem' }}></span>       
            {props.onboarding ? (
              <Button variant="success" className="mx-auto ml-lg-auto mr-lg-0" onClick={props.submitForm} >
                Save and close
              </Button>
            ) : (
              <Button variant="success" className="mx-auto ml-lg-auto mr-lg-0" onClick={handleClose} type="submit">
                Save and close
              </Button>
              
            )}
        </Modal.Footer>
      </Modal>
    </>
  );
}
